/*
  Different tour types.
 */
const TOUR_TYPES = {
  PRODUCT: "PRODUCT"
};

export { TOUR_TYPES };
